export default {"src":"/app/presentation/_next/static/media/3x3_for_dark_themes.bd87a288.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};